import {
  setToken,
  getToken,
  getCookies,
  setCookies,
  removeCookies
} from '@/utils/auth'
import axios from "@/utils/request.js"

const user = {
  state: {
    token: getToken(),
    Id: getCookies('Id'),
    AgencyName: getCookies('AgencyName'),
    AgencyArea: getCookies('AgencyArea'),
    ShareRatio: getCookies('ShareRatio'),
    CommissionRatio: getCookies('CommissionRatio'),
    AgencyBalance: getCookies('AgencyBalance'),
    EarningOfPaying: getCookies('EarningOfPaying'),
    StoreGoodsSwitch: getCookies('StoreGoodsSwitch'),
    Special: getCookies('Special'),
    UnreadCount: 0,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ID: (state, Id) => {
      state.Id = Id
    },
    SET_AGENCYNAME: (state, AgencyName) => {
      state.AgencyName = AgencyName
    },
    SET_AGENCYAREA: (state, AgencyArea) => {
      state.AgencyArea = AgencyArea
    },
    SET_SHARERATIO: (state, ShareRatio) => {
      state.ShareRatio = ShareRatio
    },
    SET_COMMISSIONRATIO: (state, CommissionRatio) => {
      state.CommissionRatio = CommissionRatio
    },
    SET_AGENCYBALANCE: (state, AgencyBalance) => {
      state.AgencyBalance = AgencyBalance
    },
    SET_EARNINGOFPAYING: (state, EarningOfPaying) => {
      state.EarningOfPaying = EarningOfPaying
    },
    SET_StoreGoodsSwitch: (state, StoreGoodsSwitch) => {
      state.StoreGoodsSwitch = StoreGoodsSwitch;
    },
    SET_SPECIAL: (state, Special) => {
      state.Special = Special
    },
    SET_UNREADCOUNT: (state, UnreadCount) => {
      state.UnreadCount = UnreadCount
    },
  },

  actions: {
    // 登录
    Login({
      commit
    }, AccessToken) {
      return new Promise((resolve, reject) => {
        setToken(AccessToken)
        commit('SET_TOKEN', AccessToken)
        resolve()
      })
    },
    // 获取用户信息
    GetInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        let paramList = {};
        axios.get("/api/Agency/GetAgencyInfo", paramList).then(res => {
          console.log("用户信息...", res.data);
          if (res.data && res.data.StatusCode == 200) {
            commit('SET_ID', res.data.Object.Id);
            commit('SET_AGENCYNAME', res.data.Object.AgencyName);
            commit('SET_AGENCYAREA', res.data.Object.AgencyArea);
            commit('SET_SHARERATIO', res.data.Object.ShareRatio);
            commit('SET_COMMISSIONRATIO', res.data.Object.CommissionRatio);
            commit('SET_AGENCYBALANCE', res.data.Object.AgencyBalance);
            commit('SET_EARNINGOFPAYING', res.data.Object.EarningOfPaying);
            commit('SET_StoreGoodsSwitch', res.data.Object.StoreGoodsSwitch);
            commit('SET_SPECIAL', res.data.Object.Special);
            setCookies("Id", res.data.Object.Id);
            setCookies("AgencyName", res.data.Object.AgencyName);
            setCookies("ShareRatio", res.data.Object.ShareRatio);
            setCookies("CommissionRatio", res.data.Object.CommissionRatio);
            setCookies("AgencyBalance", res.data.Object.AgencyBalance);
            setCookies("EarningOfPaying", res.data.Object.EarningOfPaying);
            setCookies("StoreGoodsSwitch", res.data.Object.StoreGoodsSwitch);
            setCookies("Special", res.data.Object.Special); //用户是否有查看下级网吧统计的权限
          } else { }
          resolve()
        });
      })
    },
    // 获取未读信息
    GetCount({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        let paramList = {};
        axios.get("/api/Message/GetMessageTypeCount", paramList).then(res => {
          if (res.status == 200) {
            var UnreadCount = JSON.stringify(res.data.UnreadCount) || 0;
            commit('SET_UNREADCOUNT', UnreadCount);
          }
          resolve()
        });
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js